import { render, staticRenderFns } from "./AssessmentSidebar.vue?vue&type=template&id=02d8fd0e&"
import script from "./AssessmentSidebar.vue?vue&type=script&lang=js&"
export * from "./AssessmentSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports